import axios from 'axios';
import Vue from 'vue';
import moment from 'moment';
import store from '@/store';
import authService from '@/services/authService';

// Polifyll for Edge 16
// let URLSearchParams = require('url-search-params');

export default {
  withAuthorizationToken(url) {
    if (url.indexOf('/oauth/access_token') >= 0) {
      return false;
    }
    if (url.indexOf('/dps/password/forgot') >= 0) {
      return false;
    }
    if (url.indexOf('/api/login') >= 0) {
      return false;
    }
    return true;
  },
  init() {
    let self = this;
    axios.interceptors.request.use(
      function (config) {
        if (!self.withAuthorizationToken(config.url)) {
          return config;
        }

        var data = store.state.token;

        if (typeof data !== 'undefined' && data !== null) {
          var momentExpiration = moment(data.expirationDate);
          var now1Minutes = moment().add(10, 'minutes');

          if (now1Minutes.isAfter(momentExpiration)) {
            let apiUrl = store.state.apiSelected.apiHost;

            // We do not use URLSearchParams because it's not supported in Edge 16
            // so we write the URLSearchParams in the URL
            // let params = new URLSearchParams();
            // params.append('grant_type', 'refresh_token');
            // params.append('refresh_token', data.refresh_token);

            return axios
              .post(`${apiUrl}/oauth/access_token?grant_type=refresh_token&refresh_token=${data.refresh_token}`)
              .then(function (resp) {
                store.commit('UPDATE_TOKEN', resp.data);

                data = store.state.token;
                config.headers['Authorization'] = `${data.token_type} ${data.access_token}`;
                return Promise.resolve(config);
              })
              .catch(function (error) {
                authService.logout();
                console.log(error);
              });
          } else {
            config.headers['Authorization'] = `${data.token_type} ${data.access_token}`;
          }
        }
        return config;
      },
      function (error) {
        return Promise.reject(error);
      }
    );

    axios.interceptors.response.use(
      function (config) {
        return config;
      },
      function (error) {
        // Do something with response error
        if (error.response.status === 401) {
          if (error.config.url.indexOf('/api/login') >= 0) {
            return Promise.reject(error.response);
          } else {
            authService.logout();
          }
        }
        if (error.response.status === 500) {
          console.log(500);
        }

        if (error.response.status === 401 || error.response.status === 403) {
          authService.logout();
        }
        return Promise.reject(error.response);
      }
    );

    Vue.prototype.$http = axios;
  }
};



// WEBPACK FOOTER //
// ./src/config/axiosInterceptors.js